import { render, staticRenderFns } from "./saapprove.vue?vue&type=template&id=01a8b0ce&scoped=true"
import script from "./saapprove.vue?vue&type=script&lang=js"
export * from "./saapprove.vue?vue&type=script&lang=js"
import style0 from "./saapprove.vue?vue&type=style&index=0&id=01a8b0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8b0ce",
  null
  
)

export default component.exports